import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { apiCall } from '@/utils/apiAxios';
import { Auxiliaries } from '@/types/permissions/permissions';
import { useAgentStore } from "@/stores/agent";

export const usePermitsStore = defineStore('permitsStore', () => {
    const permissions = ref<Array>([]);
    const permissionsUser = ref<Array>([]);
    const roles = ref<Array>([]);
    const auxiliaries = ref<Auxiliaries>([]);

    const agentStore = useAgentStore();


    const getPermits = async (user_id = '') => {
        
        const data = {
            user_id,
            platform: 'brokerin'
        };

        const { request } = await apiCall({
            method: 'get',
            url: `/permissions/api/permissions/permissions`,
            params: data
        });

        const response = await request;
        if (response.status == 1) {
            permissions.value = response.response.permissions;
            roles.value = response.response.roles;
  
            
            if(user_id == ''){
                permissionsUser.value = response.response.permissions
               localStorage.setItem('permissionsUser', JSON.stringify(permissionsUser.value));

            }
           


            localStorage.setItem('permits', JSON.stringify(permissions.value));
        }
    };

    const toggleUserPermission = async (permission: object) => {
        const { request } = await apiCall({
            method: 'post',
            url: `/permissions/api/permissions/toggle_user_permission`,
            data: permission
        });

        const response = await request;
        if (response.status == 1) {
         
        }
    }


    const updateLabel = async (labels: object) => {
        const { request } = await apiCall({
            method: 'post',
            url: `/permissions/api/permissions/update_label`,
            data: labels
        });

        const response = await request;
        if (response.status == 1) {
         
        }
    }
    const createRole = async (role: object) => {
        const { request } = await apiCall({
            method: 'post',
            url: `/permissions/api/permissions/create_role`,
            data: role
        });

        const response = await request;
        if (response.status == 1) {
         
        }
    }

    const assignRole = async (userRoles: object) => {

        const { request } = await apiCall({
            method: 'post',
            url: `/permissions/api/permissions/assign_user_role`,
            data: userRoles
        });

        const response = await request;
        if (response.status == 1) {
         
        }
    } 


    const removeRol = async (userRoles: object)=> {
        const { request } = await apiCall({
            method: 'post',
            url: `/permissions/api/permissions/remove_user_role`,
            data: userRoles
        });

        const response = await request;
        if (response.status == 1) {
         
        }
    }


    const getAuxiliaries = async () => {
        const data = {};

        const { request } = await apiCall({
            method: 'get',
            url: `/brokerin/api/auxiliaries`,
 
            params: { agent_hash: agentStore.agentHash,}
        });

        const response = await request;
        
        if (response.status == 1) {
            auxiliaries.value = response.response

       
          

            

            localStorage.setItem('auxiliaries', JSON.stringify(permissions.value));
        }
    };


    const getAuxiliariesInfo = (auxiliariesId: string) => {
        let assistant = auxiliaries.value.find((i) => i.id == auxiliariesId);
        if (assistant) {
            return assistant;
        } else {
            return { value: '0', label: 'Sin datos', friendly_name: 'Sin datos', color: 'gray' };
        }
    };



    return {
        permissions,
        roles,
        auxiliaries,
        permissionsUser,
        getPermits,
        toggleUserPermission,
        updateLabel,
        createRole,
        assignRole,
        removeRol,
        getAuxiliaries,
        getAuxiliariesInfo
    };
});